<div class="section">



    <!--     *********     BLOGS 1      *********      -->
    <div class="blog-1" id="blog-1">
        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <h3 class="title">Privacy Policy</h3>
                    <br />

                    <h4 style="line-height: 2;">INTRODUCTION</h4>
                    <p style="line-height: 2;">eMD Technologies, respects the privacy of our users. This Privacy Policy
                        explains how we collect, use, disclose, and safeguard your information when you visit our
                        website <a href="https://e-md.co.za">www.e-md.co.za</a>, including any other media form, media channel, mobile website, or mobile
                        application related or connected thereto (collectively, the “Site”). Please read this privacy
                        policy carefully. If you do not agree with the terms of this privacy policy, please do not
                        access the site.</p>
                    <p style="line-height: 2;">We reserve the right to make changes to this Privacy Policy at any time
                        and for any reason. We will alert you about any changes by updating the “Last Updated” date of
                        this Privacy Policy. Any changes or modifications will be effective immediately upon posting the
                        updated Privacy Policy on the Site, and you waive the right to receive specific notice of each
                        such change or modification.</p>
                    <p style="line-height: 2;">You are encouraged to periodically review this Privacy Policy to stay
                        informed of updates. You will be deemed to have been made aware of, will be subject to, and will
                        be deemed to have accepted the changes in any revised Privacy Policy by your continued use of
                        the Site after the date such revised Privacy Policy is posted.</p>

                    <h4 style="line-height: 2;">COLLECTION OF YOUR INFORMATION</h4>
                    <p style="line-height: 2;">We may collect information about you in a variety of ways. The
                        information we may collect on the Site includes:</p>
                    <h5 style="line-height: 2;">Personal Data</h5>
                    <p style="line-height: 2;">
                        Personally identifiable information, such as your name, shipping address, email address, and
                        telephone number, and demographic information, such as your age, gender, hometown, and
                        interests, that you voluntarily give to us when you register with the Site or when you choose to
                        participate in various activities related to the Site, such as online chat and message boards.
                        You are under no obligation to provide us with personal information of any kind, however your
                        refusal to do so may prevent you from using certain features of the Site.</p>

                    <h5 style="line-height: 2;">Derivative Data</h5>
                    <p style="line-height: 2;">
                        Information our servers automatically collect when you access the Site, such as your IP address,
                        your browser type, your operating system, your access times, and the pages you have viewed
                        directly before and after accessing the Site. If you are using our mobile application, this
                        information may also include your device name and type, your operating system, your phone
                        number, your country, your likes and replies to a post, and other interactions with the
                        application and other users via server log files, as well as any other information you choose to
                        provide.</p>

                    <h5 style="line-height: 2;">Financial Data</h5>
                    <p style="line-height: 2;">
                        Financial information, such as data related to your payment method (e.g. valid credit card
                        number, card brand, expiration date) that we may collect when you purchase, order, return,
                        exchange, or request information about our services from the Site or our mobile application. We
                        store financial information that we collect. Otherwise, all financial information is stored by
                        our payment processor, and you are encouraged to review their privacy policy and contact them
                        directly for responses to your questions.</p>

                    <h5 style="line-height: 2;">Facebook Permissions</h5>
                    <p style="line-height: 2;">
                        The Site may by default access your Facebook basic account information, including your name,
                        email, gender, birthday, current city, and profile picture URL, as well as other information
                        that you choose to make public. We may also request access to other permissions related to your
                        account, such as friends, check-ins, and likes, and you may choose to grant or deny us access to
                        each individual permission. For more information regarding Facebook permissions, refer to the
                        Facebook Permissions Reference page.</p>

                    <h5 style="line-height: 2;">Data from Social Networks</h5>
                    <p style="line-height: 2;">
                        User information from social networking sites, such as Apple’s Game Center, Facebook, Google+,
                        Instagram, Pinterest, Twitter, including your name, your social network username, location,
                        gender, birth date, email address, profile picture, and public data for contacts, if you connect
                        your account to such social networks. If you are using our mobile application, this information
                        may also include the contact information of anyone you invite to use and/or join our mobile
                        application.</p>

                        <h5 style="line-height: 2;">Mobile Device Data</h5>
                    <p style="line-height: 2;">
                        Device information, such as your mobile device ID, model, and manufacturer, and information
                        about the location of your device, if you access the Site from a mobile device.</p>

                    <h5 style="line-height: 2;">Third-Party Data</h5>
                    <p style="line-height: 2;">
                        Information from third parties, such as personal information or network friends, if you connect
                        your account to the third party and grant the Site permission to access this information.</p>

                    <h5 style="line-height: 2;">Data from Contests, Giveaways, and Surveys</h5>
                    <p style="line-height: 2;">
                        Personal and other information you may provide when entering contests or giveaways and/or
                        responding to surveys.</p>


                    <h5 style="line-height: 2;">Mobile Application Information</h5>
                    <p style="line-height: 2;">
                        If you connect using our mobile application:</p>


                    <p style="line-height: 2;">
                        <br> ● <strong>Geo-Location Information.</strong> We may request access or permission to and
                        tracklocation-based
                        information from your mobile device, either continuously or whileyou are using our mobile
                        application, to provide location-based services. If you wish to change our access or
                        permissions, you may do so in your device’ssettings.
                    </p>
                    <p style="line-height: 2;">
                        <br> ● <strong>Mobile Device Access.</strong> We may request access or permission to certain
                        featuresfrom your mobile
                        device, including your mobile device’s bluetooth, calendar,camera, contacts, microphone,
                        reminders, sensors, SMS messages, social mediaaccounts, storage, and other features. If you wish
                        to change our access orpermissions, you may do so in your device’s settings.
                    </p>
                    <p style="line-height: 2;">
                        <br> ● <strong>Mobile Device Data.</strong> We may collect device information (such as your
                        mobiledevice ID, model and
                        manufacturer), operating system, version information andIP address.
                    </p>

                    <p style="line-height: 2;">
                        <br> ● <strong>Push Notifications.</strong> We may request to send you push notifications regarding
                        youraccount or the
                        Application. If you wish to opt-out from receiving these types of communications, you may turn
                        them off in your device’s settings.
                    </p>

                    <h4 style="line-height: 2;">USE OF YOUR INFORMATION</h4>
                    <p style="line-height: 2;">Having accurate information about you permits us to provide you with a
                        smooth, efficient, and customized experience. Specifically, we may use information collected
                        about you via the Site or our mobile application to:</p>

                    <p style="line-height: 2;">
                        ● Administer sweepstakes, promotions, and contests.
                        <br> ● Assist law enforcement and respond to subpoena.
                        <br> ● Compile anonymous statistical data and analysis for use internally or with thirdparties.
                        <br> ● Create and manage your account.
                        <br> ● Deliver targeted advertising, coupons, newsletters, and other informationregarding
                        promotions
                        and the Site to you.
                        <br> ● Email you regarding your account or order.
                        <br> ● Enable user-to-user communications.
                        <br> ● Fulfill and manage purchases, orders, payments, and other transactions relatedto the
                        Site.
                        <br> ● Generate a personal profile about you to make future visits to the Site morepersonalized.
                        <br> ● Increase the efficiency and operation of the Site.
                        <br> ● Monitor and analyze usage and trends to improve your experience with the Site.
                        <br> ● Notify you of updates to the Site.
                        <br> ● Offer new products, services and/or recommendations to you.
                        <br> ● Perform other business activities as needed.
                        <br> ● Prevent fraudulent transactions, monitor against theft, and protect against criminal
                        activity.
                        <br> ● Process payments and refunds.
                        <br> ● Request feedback and contact you about your use of the Site.
                        <br> ● Resolve disputes and troubleshoot problems.
                        <br> ● Respond to product and customer service requests.
                        <br> ● Send you a newsletter.
                        <br> ● Solicit support for the Site.

                    </p>

                    <h4 style="line-height: 2;">DISCLOSURE OF YOUR INFORMATION</h4>
                    <p style="line-height: 2;">We may share information we have collected about you in certain
                        situations. Your information may be disclosed as follows:</p>


                    <h5 style="line-height: 2;">By Law or to Protect Rights</h5>
                    <p style="line-height: 2;">
                        If we believe the release of information about you is necessary to respond to legal process, to
                        investigate or remedy potential violations of our policies, or to protect the rights, property,
                        and safety of others, we may share your information as permitted or required by any applicable
                        law, rule, or regulation. This includes exchanging information with other entities for fraud
                        protection and credit risk reduction.</p>

                    <h5 style="line-height: 2;">Third-Party Service Providers</h5>
                    <p style="line-height: 2;">
                        We will not share your information with third parties that perform services for us or on our
                        behalf, including payment processing, data analysis, email delivery, hosting services, customer
                        service, and marketing assistance.</p>


                    <h5 style="line-height: 2;">Marketing Communications</h5>
                    <p style="line-height: 2;">
                        We will not share your information with third parties for marketing purposes.</p>



                    <h5 style="line-height: 2;">Interactions with Other Users</h5>
                    <p style="line-height: 2;">
                        If you interact with other users of the Site, those users may see your name, profile photo, and
                        descriptions of your activity, including sending invitations to other users, chatting with other
                        users, liking posts, following blogs.</p>

                    <h5 style="line-height: 2;">Online Postings</h5>
                    <p style="line-height: 2;">
                        When you post comments, contributions or other content to the Site or our mobile applications,
                        your posts may be viewed by all users and may be publicly distributed outside the Site in
                        perpetuity.</p>


                    <h5 style="line-height: 2;">Third-Party Advertisers</h5>
                    <p style="line-height: 2;">
                        We may use third-party advertising companies to serve ads when you visit the Site or our mobile
                        application. These companies may use information about your visits to the Site and other
                        websites that are contained in web cookies in order to provide advertisements about goods and
                        services of interest to you.</p>

                    <h5 style="line-height: 2;">Affiliates</h5>
                    <p style="line-height: 2;">
                        We may share your information with our affiliates, in which case we will require those
                        affiliates to honor this Privacy Policy. Affiliates include our parent company and any
                        subsidiaries, joint venture partners or other companies that we control or that are under common
                        control with us.</p>

                    <h5 style="line-height: 2;">Business Partners</h5>
                    <p style="line-height: 2;">
                        We may share your information with our business partners to offer you certain products, services
                        or promotions.</p>


                    <h5 style="line-height: 2;">Social Media Contacts</h5>
                    <p style="line-height: 2;">
                        If you connect to the Site or our mobile application through a social network, your contacts on
                        the social network will see your name, profile photo, and descriptions of your activity.</p>


                    <h5 style="line-height: 2;">Other Third Parties</h5>
                    <p style="line-height: 2;">
                        We may share your information with advertisers and investors for the purpose of conducting
                        general business analysis. We may also share your information with such third parties for
                        marketing purposes, as permitted by law.</p>


                    <h5 style="line-height: 2;">Sale or Bankruptcy</h5>
                    <p style="line-height: 2;">
                        If we reorganize or sell all or a portion of our assets, undergo a merger, or are acquired by
                        another entity, we may transfer your information to the successor entity. If we go out of
                        business or enter bankruptcy, your information would be an asset transferred or acquired by a
                        third party. You acknowledge that such transfers may occur and that the transferee may decline
                        honor commitments we made in this Privacy Policy.</p>


                    <p style="line-height: 2;">
                        We are not responsible for the actions of third parties with whom you share personal or
                        sensitive data, and we have no authority to manage or control third-party solicitations. If you
                        no longer wish to receive correspondence, emails or other communications from third parties, you
                        are responsible for contacting the third party directly.
                    </p>

                    <h4 style="line-height: 2;">TRACKING TECHNOLOGIES</h4>

                    <h5 style="line-height: 2;">Cookies and Web Beacons</h5>
                    <p style="line-height: 2;">
                        We may use cookies, web beacons, tracking pixels, and other tracking technologies on the Site to
                        help customize the Site and improve your experience. When you access the Site or our mobile
                        application, your personal information is not collected through the use of tracking technology.
                        Most browsers are set to accept cookies by default. You can remove or reject cookies, but be
                        aware that such action could affect the availability and functionality of the Site or our mobile
                        application. You may not decline web beacons. However, they can be rendered ineffective by
                        declining all cookies or by modifying your web browser’s settings to notify you each time a
                        cookie is tendered, permitting you to accept or decline cookies on an individual basis.</p>

                    <p style="line-height: 2;">We may use cookies, web beacons, tracking pixels, and other tracking
                        technologies on the Site to help customize the Site and improve your experience. For more
                        information on how we use cookies, please refer to our Cookie Policy posted on the Site, which
                        is incorporated into this Privacy Policy. By using the Site, you agree to be bound by our Cookie
                        Policy.</p>

                    <h5 style="line-height: 2;">Internet-Based Advertising</h5>
                    <p style="line-height: 2;">
                        Additionally, we may use third-party software to serve ads on the Site, implement email
                        marketing campaigns, and manage other interactive marketing initiatives. This third-party
                        software may use cookies or similar tracking technology to help manage and optimize your online
                        experience with us. For more information about opting-out of interest-based ads, visit the
                        Network Advertising Initiative Opt-Out Tool or Digital Advertising Alliance Opt-Out Tool.</p>

                    <h5 style="line-height: 2;">Website Analytics</h5>
                    <p style="line-height: 2;">
                        We may also partner with selected third-party vendors, such as Google Analytics, and others, to
                        allow tracking technologies and remarketing services on the Site through the use of first party
                        cookies and third-party cookies, to, among other things, analyze and track users’ use of the
                        Site, determine the popularity of certain content and better understand online activity. By
                        accessing the Site, our mobile application, you consent to the collection and use of your
                        information by these third-party vendors. You are encouraged to review their privacy policy and
                        contact them directly for responses to your questions. We do not transfer personal information
                        to these third-party vendors. However, if you do not want any information to be collected and
                        used by tracking technologies, you can visit the third-party vendor or the Network Advertising
                        Initiative Opt-Out Tool or Digital Advertising Alliance Opt-Out Tool.</p>

                    <p style="line-height: 2;">
                        You should be aware that getting a new computer, installing a new browser, upgrading an existing
                        browser, or erasing or otherwise altering your browser’s cookies files may also clear certain
                        opt-out cookies, plug-ins, or settings.
                    </p>

                    <h4 style="line-height: 2;">SECURITY OF YOUR INFORMATION</h4>
                    <p style="line-height: 2;">We use administrative, technical, and physical security measures to help
                        protect your personal information. While we have taken reasonable steps to secure the personal
                        information you provide to us, please be aware that despite our efforts, no security measures
                        are perfect or impenetrable, and no method of data transmission can be guaranteed against any
                        interception or other type of misuse. Any information disclosed online is vulnerable to
                        interception and misuse by unauthorized parties. Therefore, we cannot guarantee complete
                        security if you provide personal information.</p>


                    <h4 style="line-height: 2;">POLICY FOR CHILDREN</h4>
                    <p style="line-height: 2;">
                        We do not knowingly solicit information from or market to children under the age of 13. If you
                        become aware of any data we have collected from children under age 13, please contact us using
                        the contact information provided below.</p>


                    <h4 style="line-height: 2;">CONTROLS FOR DO-NOT-TRACK FEATURES</h4>
                    <p style="line-height: 2;">Most web browsers and some mobile operating systems and our mobile
                        application include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your
                        privacy preference not to have data about your online browsing activities monitored and
                        collected. No uniform technology standard for recognizing and implementing DNT signals has been
                        finalized. As such, we do not currently respond to DNT browser signals or any other mechanism
                        that automatically communicates your choice not to be tracked online. If a standard for online
                        tracking is adopted that we must follow in the future, we will inform you about that practice in
                        a revised version of this Privacy Policy./Most web browsers and some mobile operating systems
                        and our mobile applications include a Do-Not-Track (“DNT”) feature or setting you can activate
                        to signal your privacy preference not to have data about your online browsing activities
                        monitored and collected. If you set the DNT signal on your browser, we will respond to such DNT
                        browser signals.</p>

                    <h4 style="line-height: 2;">OPTIONS REGARDING YOUR INFORMATION</h4>

                    <h5 style="line-height: 2;">Account Information</h5>
                    <p style="line-height: 2;">
                        You may at any time review or change the information in your account or terminate your account
                        by:
                        <br> ● Logging into your account settings and updating your account
                        <br> ● Contacting us using the contact information provided below
                        <br>Upon your request to terminate your account, we will deactivate or delete your account and
                        information from our active databases. However, some information may be retained in our files to
                        prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of Use
                        and/or comply with legal requirements.
                    </p>

                    <h5 style="line-height: 2;">Emails and Communications</h5>
                    <p style="line-height: 2;">
                        If you no longer wish to receive correspondence, emails, or other communications from us, you
                        may opt-out by:
                        <br> ● Noting your preferences at the time you register your account with the Site or ourmobile
                        application
                        <br> ● Logging into your account settings and updating your preferences.
                        <br> ● Contacting us using the contact information provided below
                        <br>If you no longer wish to receive correspondence, emails, or other communications from third
                        parties, you are responsible for contacting the third party directly.</p>

                    <h5 style="line-height: 2;">CONTACT US</h5>
                    <p style="line-height: 2;">
                        If you have questions or comments about this Privacy Policy, please contact us.</p>

                </div>
            </div>
        </div>
    </div>

</div>